module.exports = __webpack_public_path__ + "static/img/dummy-400x300-SeagullLanding-plain.8713d5c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dummy-400x300-SeagullLanding-plain.jpg
// module id = Ocs+
// module chunks = 0